const escapeCsvCell = (value: string | number): string => {
  const str = String(value);
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

/** Builds a CSV file from rows of cells and triggers a browser download for it. */
export const downloadCsv = (filename: string, rows: (string | number)[][]): void => {
  const csv = rows.map((row) => row.map(escapeCsvCell).join(",")).join("\r\n");
  // Leading BOM so Excel opens the file as UTF-8 instead of guessing a legacy codepage.
  const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
